import logoImage from "../../assest/images/logo-img.png"
import { Link } from "react-router-dom";
import LastBox from "../../components/LastBox";
import ReCAPTCHA from 'react-google-recaptcha';
import prularo from "../../assest/myImages/PLURALO_LOGO_WEBSITE.png";
import "../../assest/css/login.css";
import ProviderList from "../../components/ProviderList";
import helper from "../../common/Helper";

const Index = ({
    state,
    sendMail,
    changeValue,
    isLoading,
    setRecaptchaToken
}) => {
    const { error, email } = state;
    return (
        <div className="sq-wrapper">
            <div className="sq-left">
                <a href={helper.touristUrl} target="_blank"><img src={logoImage} alt="logo-img" className="logo-img" /></a>
                <div className="sq-form-section">
                    <h1 className="sq-heading">Forgot your password?<br />
                        Let's help you reset it.
                    </h1>
                    <form onSubmit={sendMail}>
                        <div className="sq-input-wrap">
                            <label className="sq-label" htmlFor="sq-email">Email</label>
                            <div style={{position:"relative"}}>
                                <span className="sq-input-icon">
                                    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                </span>
                                <input id="sq-email" className="sq-input" name="email" type="email" value={email} placeholder="Enter your email" onChange={changeValue} required />
                                {error && error.email && <span className="cus-err login-err">{error.email}</span>}
                            </div>
                        </div>

                        <button className="common-btn sq-btn-primary" type="submit" disabled={isLoading}>
                            {isLoading ? "Loading..." : "Send Mail"}
                            {!isLoading && <i className="fa-solid fa-chevron-right"></i>}
                        </button>
                    </form>
                    <div className="sq-divider">OR</div>

                    <p className="sq-signup-link">Back to <Link to={"/login"}>Login</Link></p>
                </div>
            </div>

            <div className="sq-right">

                <div className="sq-right-content">
                    <h2 className="sq-hero-title">Welcome to the<br /> Supplier Portal</h2>

                    <div className="sq-quote-block">
                        <p className="sq-quote-text">Simplify tour management, monitor real-time reservations, and keep your explorers prepared for their next thrill. Everything you need to organize, grow, and scale your adventure offerings: all in one place.</p>
                    </div>
                </div>

                <div className="sq-logos-section">
                    <div className="sq-logos-divider"></div>
                    <div className="sq-logos-label">We work with</div>
                    <div className="sq-logos-row">
                        <ProviderList />
                    </div>
                </div>
            </div>
        </div>
    )

}
export default Index;
